export default function SkillLevels() {
  const levels = [
    {
      title: 'Beginner',
      icon: 'ri-seedling-line',
      description: 'Learn the fundamentals of Brawlhalla combat, movement mechanics, and basic combos.',
      features: [
        'Basic movement and dodging',
        'Weapon fundamentals',
        'Simple combo chains',
        'Stage awareness',
        'Character selection guide'
      ],
      color: 'from-green-600 to-green-700'
    },
    {
      title: 'Intermediate',
      icon: 'ri-sword-line',
      description: 'Master advanced techniques, string combos, and develop your competitive playstyle.',
      features: [
        'Advanced combo strings',
        'Edge guarding techniques',
        'Weapon throw mechanics',
        'Reading opponents',
        'Tournament preparation'
      ],
      color: 'from-blue-600 to-blue-700'
    },
    {
      title: 'Advanced',
      icon: 'ri-vip-crown-line',
      description: 'Perfect your gameplay with pro-level strategies, frame data analysis, and mental game.',
      features: [
        'Frame-perfect execution',
        'Advanced mind games',
        'Meta analysis',
        'Professional VOD review',
        'Tournament strategy'
      ],
      color: 'from-purple-600 to-purple-700'
    }
  ];

  return (
    <section className="py-20 px-6 bg-gray-900">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Training Programs for Every Level
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Whether you're just starting out or competing at the highest level, 
            we have the perfect training program to help you improve.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {levels.map((level, index) => (
            <div 
              key={index}
              className="bg-gray-800 rounded-xl overflow-hidden hover:transform hover:scale-105 transition-all duration-300 cursor-pointer"
            >
              <div className={`bg-gradient-to-r ${level.color} p-6 text-center`}>
                <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${level.icon} text-white text-4xl`}></i>
                </div>
                <h3 className="text-2xl font-bold text-white">{level.title}</h3>
              </div>
              
              <div className="p-6">
                <p className="text-gray-300 mb-6">{level.description}</p>
                
                <div className="space-y-3 mb-6">
                  {level.features.map((feature, idx) => (
                    <div key={idx} className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-purple-400 mt-1 mr-3"></i>
                      <span className="text-gray-300">{feature}</span>
                    </div>
                  ))}
                </div>

                <button className="w-full bg-purple-600 hover:bg-purple-700 text-white py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap">
                  Start Training
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
